import React from "react";
// import { useSelector } from "react-redux";
import { ReactComponent as CheckIcon } from '../../../../../../assets/icons/check_purple_icon.svg'

const ActionList = (props) =>{
    // const locales = useSelector(state => state.forms?.localeStrings);

    return(
        <div className="popover-container">
            { <div className="popover-item" onClick={()=>props.setViewOpen(true)}>View<CheckIcon className="check"/></div> }
            { <div className="popover-item" onClick={()=>props.setEditOpen(true)}><span>Edit<CheckIcon className="check"/></span></div> }
            { <div className="popover-item" onClick={()=>props.setAddKeyOpen(true)}><span>Add Key/Value<CheckIcon className="check"/></span></div> }
        </div>
    )
}

export default ActionList;